// One line under the Focus project picker, shown only while the user's GitHub
// connection exists but Loom can no longer renew it (`usable: false`): that is
// when their GitHub projects silently drop out of the list. It links to the
// account page, where the row says which connection and offers Reconnect.
//
// Silent in every other case — GitHub off here (404), a failed read, not
// connected, or connected and usable. `usable` only sees an expired credential;
// a grant revoked at github.com reads as usable, and the account page's
// always-offered Reconnect is the remedy for that.

import { useEffect, useState } from "react";

import { readGitHubStatus } from "../components/GitHubConnection";
import { useT } from "../i18n/index.js";

import { AccountNavLink } from "./AccountNavLink";

export function LapsedConnectionHint() {
  const t = useT();
  const [lapsed, setLapsed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    readGitHubStatus()
      .then((status) => {
        if (!cancelled) setLapsed(status.connected && status.usable === false);
      })
      .catch(() => {
        /* GitHub off here, or the read failed: no hint */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!lapsed) return null;
  return (
    <p className="focus-note account-hint">
      {t("account.hint.lapsed")}{" "}
      <AccountNavLink label="account.hint.open" />
    </p>
  );
}
